import { useMutation } from '@tanstack/react-query'
import { EMPLOYEE_CREDIT_CUSTOMER_UPDATE_ERRORS } from 'businessTraveller/api/creditCustomerErrors'
import requestPatchMyCreditCustomerId from 'businessTraveller/api/requestPatchMyCreditCustomerId'

interface BusinessTravellerEmployeeCustomerCreditIdUpdateVariables {
  accessToken: string
  businessId: string
}

interface Params {
  onSuccess?: () => void
}

function useBusinessTravellerCreditCustomerUpdateMutation(params: Params) {
  const { onSuccess } = params

  const creditCustomerIdUpdateMutation = useMutation<boolean, EMPLOYEE_CREDIT_CUSTOMER_UPDATE_ERRORS, BusinessTravellerEmployeeCustomerCreditIdUpdateVariables>({
    mutationFn: ({ accessToken, businessId }) => requestPatchMyCreditCustomerId({ businessId, linkedAccountToken: accessToken }),
    onSuccess: (data) => {
      if (data) {
        onSuccess?.()
      }
    },
  })

  return creditCustomerIdUpdateMutation
}

export default useBusinessTravellerCreditCustomerUpdateMutation
